import { ConnectionDirection } from 'src/lib/fliko/models/connection/connection.data';
import { NewsNotificationType, NewsType } from 'src/lib/fliko/models/news/news.data';
import { RentalUnitType } from 'src/lib/fliko/models/units/unit.data';
import { WebsiteCategory } from 'src/lib/fliko/models/website/website.data';

export type MatIconEnum =
  | NewsNotificationType
  | NewsType
  | RentalUnitType
  | 'agreement'
  | WebsiteCategory
  | 'calendly'
  | ConnectionDirection
  | 'resident';
export type MatIconKey = MatIconEnum | `${MatIconEnum}`;

export class MatIconHlp {
  public static get(key: MatIconEnum): string {
    switch (key) {
      case NewsNotificationType.EMAIL:
        return 'mail';
      case NewsNotificationType.SMS:
        return 'sms';
      case NewsNotificationType.MOBILE:
        return 'notifications';
      case NewsType.ALERT:
        return 'notification_important';
      case NewsType.INFO:
        return 'info_outline';
      case NewsType.MEETING:
        return 'people';
      case NewsType.WARNING:
        return 'warning';
      case RentalUnitType.APARTMENT:
        return 'store_mall_directory';
      case RentalUnitType.PARKING:
        return 'local_parking';
      case RentalUnitType.STORAGE:
        return 'local_shipping';
      case 'agreement':
        return 'insert_drive_file';
      case WebsiteCategory.WASTE_DISPOSAL:
        return 'restore_from_trash';
      case WebsiteCategory.MEDIA_CONSUMPTION:
        return 'attach_money';
      case WebsiteCategory.LAND_REGISTER:
        return 'menu_book';
      case WebsiteCategory.OTHER:
        return 'public';
      case 'calendly':
        return 'event';
      case ConnectionDirection.INCOMING:
        return 'phone_callback';
      case ConnectionDirection.OUTGOING:
        return 'phone_forwarded';
      case 'resident':
        return 'person';
    }
  }

  /**
   * Sort icons by their index value in map (used for resolutions)
   * @param {string} a icon key
   * @param {string} b icon key
   * @return {number} difference in map value between a and b
   */
  public static sort(a: string, b: string): number {
    return (MatIconHlp.iconValMap.get(a) ?? 0) - (MatIconHlp.iconValMap.get(b) ?? 0);
  }

  private static iconValMap = new Map<string, number>([
    ['mail', 1],
    ['sms', 2],
    ['notifications', 3],
    ['notification_important', 4],
    ['info_outline', 5],
    ['people', 6],
    ['warning', 7],
    ['store_mall_directory', 8],
    ['local_parking', 9],
    ['local_shipping', 10]
  ]);
}
